<template>
  <div>
    <footer class="footer-wrap flex-item-center">
      <span>© 2025 AlSP-TW All Rights Reserved</span>
    </footer>
  </div>
</template>

<script>
import { mapState } from "vuex";
import bus from "./bus";
export default {
  name: "baseFooter",
  props: {
    msg: String
  },
  components: {},
  computed: {

  },
  data() {
    return {

    };
  },
  created() {

  },
  methods: {

    navMenu(path, index) {
      this.$router.push(path, index);
      bus.$emit("custom-event", index);
    }
  }
};
</script>

<style scoped lang="scss">
.footer-wrap {
  background: #121C32;
  height: 65px;
  font-size: 16px;
  color: #fff;
  font-weight: 600;
}

@media screen and (max-width: 1920px) {}
</style>